/**
 * @generated SignedSource<<5f201b07bb5fca97840946ae3ebb3219>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductizedServicePriceInterval = "DAY" | "HOUR" | "MONTH" | "WEEK" | "%future added value";
export type ProductizedServicePriceType = "CONTACT_FOR_PRICING" | "FIXED_PRICE" | "RATE" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type EmbeddedBuyNowLayout_productizedService$data = {
  readonly cover: {
    readonly " $fragmentSpreads": FragmentRefs<"ProjectCoverWrapper_portfolioProjectCover">;
  } | null;
  readonly price: {
    readonly amount: number | null;
    readonly interval: ProductizedServicePriceInterval | null;
    readonly timeline: string | null;
    readonly type: ProductizedServicePriceType;
  };
  readonly title: string;
  readonly userProfile: {
    readonly " $fragmentSpreads": FragmentRefs<"useSafeUserReviews_userProfile">;
  };
  readonly " $fragmentSpreads": FragmentRefs<"EmbedBuyNowCTA_productizedService">;
  readonly " $fragmentType": "EmbeddedBuyNowLayout_productizedService";
};
export type EmbeddedBuyNowLayout_productizedService$key = {
  readonly " $data"?: EmbeddedBuyNowLayout_productizedService$data;
  readonly " $fragmentSpreads": FragmentRefs<"EmbeddedBuyNowLayout_productizedService">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "EmbeddedBuyNowLayout_productizedService",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ProductizedServicePrice",
      "kind": "LinkedField",
      "name": "price",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "amount",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "interval",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "type",
          "storageKey": null
        },
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "timeline",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": null,
      "kind": "LinkedField",
      "name": "cover",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ProjectCoverWrapper_portfolioProjectCover"
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "UserProfile",
      "kind": "LinkedField",
      "name": "userProfile",
      "plural": false,
      "selections": [
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "useSafeUserReviews_userProfile"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "EmbedBuyNowCTA_productizedService"
    }
  ],
  "type": "ProductizedService",
  "abstractKey": null
};

(node as any).hash = "b817b230e29fc107e1b1d338a4886b22";

export default node;
